import { cl } from '../common/functions';

const loader = () => {
  // [LOADER] remove
  const loader = document.getElementById('map-container__loader');
  if (loader) {
    setTimeout(() => {
      loader.style.opacity = '0';
      setTimeout(() => {
        loader.style.display = 'none';
      }, 500);
    }, 1000);
  }

  // [MARKER] remove animation
  setTimeout(() => {
    const leafletMarkerPane = document.querySelector('.leaflet-marker-pane');
    if (leafletMarkerPane) {
      leafletMarkerPane.classList.add('no-animation');
    }
  }, 2500);
};

export {loader};
